import { createParser, fields } from '../utils/parse';

export const LoginParser = createParser('LoginParser', {
  id: fields.number(-1),
  allowMarketing: fields.bool(true, { path: 'allow_marketing' }),
  coins: fields.number(0),
  displayName: fields.string('', { path: 'display_name' }),
  email: fields.string('', { path: 'email_address' }),
  secondaryEmail: fields.array(fields.string(''), {
    path: 'secondary_email_addresses',
  }),
  currentCartId: fields.number(-1, { path: 'current_cart_id' }),
  isConfirmed: fields.bool(false, { path: 'is_confirmed' }),
  phoneNumbers: fields.array(fields.string(''), { path: 'phone_numbers' }),
  features: fields.array(fields.string('')),
  admin: fields.bool(false),
  firstTimeUser: fields.bool(false, { path: 'first_time_user' }),
  hasDownloadediOSApp: fields.bool(false, { path: 'has_downloaded_ios_app' }),
});

export const SignUpParser = createParser('SignUpParser', {
  id: fields.number(-1),
  displayName: fields.string('', { path: 'display_name' }),
  email: fields.string('', { path: 'email_address' }),
});
